import { css } from 'styled-components';

export const inheritedTypographyStyles = css`
  color: inherit;
  font-family: inherit;
  line-height: inherit;
`;

export const rubikTypographyStyles = css`
  font-family: Rubik, sans-serif;
`;

export const mainHeadingTypographyStyles = css`
  ${rubikTypographyStyles};
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(24)};
  font-weight: 600;
  line-height: ${({ theme }) => theme.scale.px(24)};
`;
